/**
 * Transport bar do playera
 * 
 * Wymagane w props:
 *  play, pause, loading, prev, next, restart, status
 *  no, setNo - numer ćwiczenia
 *  len - liczba elementów ćwiczenia
 * 
 */

import React, { useState } from 'react';
import PlayIcon from '@material-ui/icons/PlayArrow';
import StopIcon from '@material-ui/icons/Stop';
import NextIcon from '@material-ui/icons/SkipNext';
import PrevIcon from '@material-ui/icons/SkipPrevious';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Slider from '@material-ui/core/Slider';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  transport: {
    display: 'flex',
    alignItems: 'center',
  },
  transportMobile: {
    display: 'none',
  },
  counterMobile: {
    display: 'none',
  },
  controls: {
    whiteSpace: 'nowrap',
  },
  controlsMobile: {
    whiteSpace: 'nowrap',
    textAlign: 'center',
    width: '100%',
    '& button': {
      width: '33%'
    },
  },
  no: {
    fontWeight: 600,
    color: '#777',
    margin: '0 10px',
    whiteSpace: 'nowrap',
  },
  slider: {
    margin: '0 20px',
  },
  loading: {
    animation: 'flash 0.5s linear infinite',
  },
  '@media(max-width: 500px)': {
    transportMobile: {
      display: 'flex',
      alignItems: 'center',
    },
    counterMobile: {
      display: 'block',
      textAlign: 'center',
    },
    no: {
      display: 'none',
    },
    desktop: {
      display: 'none',
    },
  },
}));

function Transport(props) {
  const classes = useStyles();
  const {
    setNo, status, onChange, setSoundEnabled, play, pause, prev, next, no, len,
  } = props;
  const [soundBlocked, setSouondBlocked] = useState(false);

  const handleChange = (event, newValue) => {
    setNo(parseInt(newValue));
    onChange();
  };

  const handleTransportSet = () => {
    setSoundEnabled(true);
    if (soundBlocked) {
      setSouondBlocked(false);
      play();
    }
  }

  const handleMouseDown = () => {
    setSoundEnabled(false);
    setSouondBlocked(true);
  }

  const renderPlay = () => {
    return (
      <>
        {status === 'paused' && <IconButton onClick={play} title="graj">
          <PlayIcon color="primary" />
        </IconButton>}
        {status === 'playing' && <IconButton onClick={pause} title="stop">
          <StopIcon color="primary" />
        </IconButton>}
        {status === 'loading' && <IconButton title="Ładowanie pliku dźwiękowego">
          <PlayIcon color="primary" className={classes.loading} />
        </IconButton>}
      </>
    );
  }

  return (
    <>
      <div className={classes.transportMobile}>
        <div className={classes.controlsMobile}>
          <Button onClick={prev} title="poprzedni slajd">
            <PrevIcon color="primary" />
          </Button >
          {renderPlay()}
          <Button onClick={next} title="następny slajd">
            <NextIcon color="primary" />
          </Button >
        </div>
      </div>
      <div className={classes.counterMobile}>{(parseInt(no) + 1)} / {len}</div>
      <div className={classes.transport}>
        <div className={classes.controls}>
          <div className={classes.desktop}>{renderPlay()}</div>
        </div>
        <div className={classes.no}>({(parseInt(no) + 1)} / {len})</div>
        <Slider
          className={classes.slider}
          value={no}
          onChange={handleChange}
          min={0}
          max={len - 1}
          onMouseDown={handleMouseDown}
          onMouseUp={handleTransportSet}
          onMouseOut={handleTransportSet}
        />
      </div>
    </>
  );
}

export default Transport;